import styled from '@emotion/styled';

import { minDesktop } from '../styles/breakpoints';

export default styled.h2`
  font-family: 'Zilla Slab';
  font-style: normal;
  font-weight: 500;
  font-size: 26px;

  line-height: 1;

  ${minDesktop} {
    font-size: 32px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/H2/H2.js